// extracted by mini-css-extract-plugin
export default {"search_list":"Search_search_list__y7Ldf","cancel":"Search_cancel__yLLai"};